/* MONOLITH — theme behaviour. No dependencies. */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var noDecimals = Math.round(cents / 100).toString();
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  /* ---------- grid density toggle ------------------------- */

  var DENSITY_KEY = 'monolith:density';

  function initDensity() {
    var grid = $('[data-grid]');
    var toggle = $('[data-density-toggle]');
    if (!grid) return;

    var expanded = false;
    try { expanded = localStorage.getItem(DENSITY_KEY) === 'expanded'; } catch (e) {}
    grid.classList.toggle('is-expanded', expanded);

    if (!toggle) return;
    toggle.hidden = false;
    toggle.addEventListener('click', function () {
      var next = !grid.classList.contains('is-expanded');
      grid.classList.toggle('is-expanded', next);
      toggle.setAttribute('aria-pressed', String(next));
      try { localStorage.setItem(DENSITY_KEY, next ? 'expanded' : 'compact'); } catch (e) {}
    });
  }

  /* ---------- menu overlay -------------------------------- */

  function initMenu() {
    var menu = $('[data-menu]');
    if (!menu) return;
    $$('[data-menu-open]').forEach(function (b) {
      b.addEventListener('click', function () { menu.classList.add('is-open'); });
    });
    $$('[data-menu-close]').forEach(function (b) {
      b.addEventListener('click', function () { menu.classList.remove('is-open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') menu.classList.remove('is-open');
    });
  }

  /* ---------- cart ---------------------------------------- */

  var Cart = {
    drawer: null,
    backdrop: null,

    init: function () {
      Cart.drawer = $('[data-cart-drawer]');
      Cart.backdrop = $('[data-cart-backdrop]');
      if (!Cart.drawer) return;

      $$('[data-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); Cart.open(); });
      });
      $$('[data-cart-close]').forEach(function (b) {
        b.addEventListener('click', Cart.close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') Cart.close();
      });

      Cart.drawer.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cart-change]');
        if (!btn) return;
        Cart.change(btn.dataset.key, parseInt(btn.dataset.cartChange, 10));
      });
    },

    open:  function () {
      Cart.drawer.classList.add('is-open');
      Cart.drawer.setAttribute('aria-hidden', 'false');
      if (Cart.backdrop) Cart.backdrop.classList.add('is-open');
    },
    close: function () {
      if (!Cart.drawer) return;
      Cart.drawer.classList.remove('is-open');
      Cart.drawer.setAttribute('aria-hidden', 'true');
      if (Cart.backdrop) Cart.backdrop.classList.remove('is-open');
    },

    add: function (id, qty) {
      return fetch(window.theme.routes.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      }).then(function (r) {
        if (r.ok) return Cart.refresh();
        return r.json()
          .catch(function () { return {}; })
          .then(function (d) {
            throw new Error(d.description || d.message || window.theme.strings.unavailable);
          });
      });
    },

    change: function (key, qty) {
      return fetch(window.theme.routes.cart_change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { return Cart.refresh(); });
    },

    refresh: function () {
      return fetch(window.theme.routes.cart + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-contents]');
          var current = $('[data-cart-contents]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;

          var count = doc.querySelector('[data-cart-count]');
          $$('[data-cart-count]').forEach(function (el) {
            if (!count) return;
            el.textContent = count.textContent;
            el.classList.toggle('is-empty', count.textContent.trim() === '0');
          });
        });
    }
  };

  /* ---------- product ------------------------------------- */

  function initProduct() {
    var root = $('[data-product]');
    if (!root) return;

    var data = JSON.parse($('[data-product-json]', root).textContent);
    var current = data.variants.find(function (v) { return v.available; }) || data.variants[0];

    var addBtn   = $('[data-add]', root);
    var priceEl  = $('[data-price]', root);
    var noteEl   = $('[data-note]', root);
    var sizeBtns = $$('[data-variant]', root);

    function select(variant) {
      current = variant;
      sizeBtns.forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.dataset.variant, 10) === variant.id);
      });
      if (priceEl) priceEl.innerHTML = variant.compare_at_price > variant.price
        ? '<s>' + money(variant.compare_at_price) + '</s>' + money(variant.price)
        : money(variant.price);
      if (noteEl) noteEl.hidden = variant.available;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? window.theme.strings.add : window.theme.strings.sold_out;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    sizeBtns.forEach(function (b) {
      if (b.classList.contains('is-soldout')) return;
      b.addEventListener('click', function () {
        var v = data.variants.find(function (x) { return x.id === parseInt(b.dataset.variant, 10); });
        if (v) select(v);
      });
    });

    var urlVariant = new URLSearchParams(window.location.search).get('variant');
    var start = urlVariant && data.variants.find(function (v) { return v.id === parseInt(urlVariant, 10); });
    select(start || current);

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!current || !current.available) return;
        addBtn.disabled = true;
        addBtn.textContent = window.theme.strings.adding;
        Cart.add(current.id, 1)
          .then(function () {
            addBtn.textContent = window.theme.strings.added;
            Cart.open();
            setTimeout(function () {
              addBtn.textContent = window.theme.strings.add;
              addBtn.disabled = false;
            }, 1400);
          })
          .catch(function (err) {
            var msg = (err && err.message) || window.theme.strings.unavailable;
            addBtn.textContent = msg.length > 40 ? window.theme.strings.unavailable : msg;
            addBtn.disabled = false;
            setTimeout(function () { addBtn.textContent = window.theme.strings.add; }, 2500);
          });
      });
    }

    /* gallery */
    var gallery = $('[data-gallery]', root);
    if (gallery) {
      $$('[data-gallery-nav]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          gallery.scrollBy({ left: gallery.clientWidth * parseInt(b.dataset.galleryNav, 10), behavior: 'smooth' });
        });
      });
      $$('[data-slide-to]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          gallery.scrollTo({ left: gallery.clientWidth * parseInt(b.dataset.slideTo, 10), behavior: 'smooth' });
          $$('[data-slide-to]', root).forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
        });
      });
    }
  }

  /* ---------- back link ----------------------------------- */

  function initBack() {
    var link = $('[data-back]');
    if (!link) return;

    // Prefer real history so the grid keeps its scroll position and density,
    // but only when we arrived from this site — otherwise the href stands.
    link.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      var from = document.referrer;
      if (!from || from.indexOf(window.location.origin) !== 0) return;
      if (window.history.length <= 1) return;
      e.preventDefault();
      window.history.back();
    });
  }

  /* ---------- information modal --------------------------- */

  function initInfoModal() {
    var modal = $('[data-info-modal]');
    var trigger = $('[data-info-open]');
    if (!modal || !trigger) return;

    function open() {
      modal.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      // First [data-info-close] is the backdrop div, which isn't focusable.
      var close = $('button[data-info-close]', modal);
      if (close) close.focus();
    }

    function close() {
      modal.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      trigger.focus();
    }

    trigger.addEventListener('click', open);
    $$('[data-info-close]', modal).forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  /* ---------- newsletter ---------------------------------- */

  function initSignup() {
    var boxes = $$('[data-signup]');
    if (!boxes.length) return;

    // One constant key for the whole site. A per-section key meant dismissing
    // the popup on the home page did not suppress it on a collection or
    // product page, because each section instance had its own id.
    var KEY = 'monolith:signup';

    // Only ever drive the first instance, so a theme with two newsletter
    // sections shows one popup rather than stacking them.
    var box = boxes[0];

    function remember() {
      try { localStorage.setItem(KEY, 'dismissed'); } catch (e) {}
    }

    function close() {
      box.classList.remove('is-open');
      remember();
    }

    $$('[data-signup-close]', box).forEach(function (b) {
      b.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.classList.contains('is-open')) close();
    });

    // Shopify reloads with ?customer_posted=true after a successful signup.
    // Show the confirmation rather than suppressing the box, then stop
    // nagging this visitor.
    if (window.location.search.indexOf('customer_posted=true') > -1) {
      box.classList.add('is-open');
      remember();
      return;
    }

    var seen = false;
    try { seen = localStorage.getItem(KEY) === 'dismissed'; } catch (e) {}
    if (seen) return;

    setTimeout(function () {
      box.classList.add('is-open');
    }, parseInt(box.dataset.delay || '1200', 10));
  }

  /* ---------- boot ---------------------------------------- */

  function boot() {
    initDensity();
    initMenu();
    Cart.init();
    initProduct();
    initBack();
    initInfoModal();
    initSignup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  window.MonolithCart = Cart;
})();
